package com.patronat.top.client.presentation.saved

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.dto.VenueResponse

data class ClientSavedViewState(
    val isLoading: Boolean = false,
    val searchQuery: String = "",
    val venues: List<VenueResponse> = emptyList(),
    val requiresAuth: Boolean = false
) : ViewState

sealed interface ClientSavedEvent : ViewEvent {
    data object OnRefresh : ClientSavedEvent
    data class OnSearchChanged(val value: String) : ClientSavedEvent
    data class OnVenueClicked(val venueId: String) : ClientSavedEvent
    data class OnFavoriteClicked(val venueId: String) : ClientSavedEvent
}

sealed interface ClientSavedEffect : ViewSideEffect {
    data class OpenVenueDetails(val venueId: String) : ClientSavedEffect
}
